<ion-grid>
  <ion-row>
    <div class="modal-top-button">
      <ion-button color="light" (click)="dismiss()">&nbsp;</ion-button>
    </div>
    <div class="modal-title">
      <h2>Vul uw gegevens in</h2>
    </div>
    <ion-col class="over-col" size="12" style="display:flex">
      <ngx-gauge class="flexible gauge" [value]="gaugeValue" [label]="gaugeLabel" type="semi" append="%" size="150"
        thick="10" foregroundColor="#3cff63">
        <!-- <ngx-gauge-append>%</ngx-gauge-append>
        <ngx-gauge-label>2/5</ngx-gauge-label>
        <ngx-gauge-value>40</ngx-gauge-value> -->
      </ngx-gauge>
      <div class="modal-body flexible">
        <p>
          Om deze applicatie goed te kunnen gebruiken vragen we u om uw gegevens in te voeren.
          <!-- Met uw gegevens kunnen we uw mogelijke besparing op hypotheek of levensverzekering berekenen. -->
        </p>
      </div>
    </ion-col>
    <ion-col size="12">
      <div>
        <ion-button class="modal-button" (click)="goToWizard()">VUL GEGEVENS AAN</ion-button>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
